import ConfiguracaoSistema from '@/spa/configuracao-sistema/ConfiguracaoSistema';

export default {
  path: 'configuracao-sistema',
  name: 'configuracao-sistema',
  component: ConfiguracaoSistema,
};
